module.exports = __webpack_public_path__ + "img/busy.f084acb0.png";